import script from "./FormComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormComponent.vue?vue&type=style&index=0&id=17bff7d0&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17bff7d0"]])

export default __exports__